import React, { useEffect, useState } from "react";
import { hasSupabaseConfig, supabase } from "../../lib/supabaseClient";

const sources = ["chesscom", "opendota", "riot", "manual"];

const emptyForm = {
  season: "2026-Q1",
  source: "chesscom",
  source_handle: "",
  display_name: "",
  country_code: "PR",
};

export default function AdminLeaderboardsPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState("");
  const [form, setForm] = useState(emptyForm);

  async function load() {
    if (!hasSupabaseConfig || !supabase) {
      setMsg("Falta configuración de Supabase.");
      setLoading(false);
      return;
    }

    setLoading(true);
    const { data, error } = await supabase
      .from("leaderboard_profiles")
      .select("id,season,source,source_handle,display_name,country_code,active,updated_at")
      .order("updated_at", { ascending: false })
      .limit(500);

    if (error) setMsg(`Error cargando profiles: ${error.message}`);
    else setRows(data || []);
    setLoading(false);
  }

  useEffect(() => {
    load();
  }, []);

  async function addProfile(e) {
    e.preventDefault();
    setMsg("");

    const payload = {
      ...form,
      source_handle: form.source_handle.trim(),
      display_name: form.display_name.trim() || null,
      country_code: form.country_code.trim().toUpperCase() || "PR",
      active: true,
    };

    const { error } = await supabase.from("leaderboard_profiles").insert(payload);
    if (error) {
      setMsg(`No se pudo guardar: ${error.message}`);
      return;
    }

    setForm(emptyForm);
    setMsg("✅ Profile agregado.");
    load();
  }

  async function toggleActive(row) {
    const { error } = await supabase
      .from("leaderboard_profiles")
      .update({ active: !row.active })
      .eq("id", row.id);

    if (error) setMsg(`No se pudo actualizar: ${error.message}`);
    else load();
  }

  return (
    <div className="min-h-screen bg-[#06070A] text-white p-6 md:p-10">
      <div className="max-w-6xl mx-auto space-y-5">
        <div className="flex justify-between items-center gap-3 flex-wrap">
          <div>
            <h1 className="text-3xl font-bold">Admin · Leaderboards</h1>
            <p className="text-slate-300 text-sm mt-1">Configura jugadores/cuentas a trackear (TOS-safe sources). Prioriza fuentes ready: Chess.com y OpenDota.</p>
          </div>
          <div className="flex gap-2">
            <a href="/leaderboards" className="px-4 py-2 rounded-lg border border-white/20">Ver leaderboard</a>
            <a href="/admin/dashboard" className="px-4 py-2 rounded-lg border border-white/20">Dashboard</a>
          </div>
        </div>

        <form onSubmit={addProfile} className="rounded-2xl border border-white/10 bg-[#111722] p-4 grid md:grid-cols-5 gap-3">
          <input value={form.season} onChange={(e) => setForm((f) => ({ ...f, season: e.target.value }))} placeholder="Season" className="rounded bg-[#0b1019] border border-white/15 px-3 py-2" />
          <select value={form.source} onChange={(e) => setForm((f) => ({ ...f, source: e.target.value }))} className="rounded bg-[#0b1019] border border-white/15 px-3 py-2">
            {sources.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
          <input required value={form.source_handle} onChange={(e) => setForm((f) => ({ ...f, source_handle: e.target.value }))} placeholder="Source handle (username/id)" className="rounded bg-[#0b1019] border border-white/15 px-3 py-2" />
          <input value={form.display_name} onChange={(e) => setForm((f) => ({ ...f, display_name: e.target.value }))} placeholder="Display name (opcional)" className="rounded bg-[#0b1019] border border-white/15 px-3 py-2" />
          <button className="rounded bg-cyan-400 text-black font-semibold px-3 py-2">Agregar</button>
        </form>

        {msg ? <p className="text-sm text-slate-200">{msg}</p> : null}

        <div className="rounded-2xl border border-white/10 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-[#0f1420] text-slate-300">
                <tr>
                  <th className="px-3 py-2 text-left">Season</th>
                  <th className="px-3 py-2 text-left">Source</th>
                  <th className="px-3 py-2 text-left">Handle</th>
                  <th className="px-3 py-2 text-left">Display</th>
                  <th className="px-3 py-2 text-left">Country</th>
                  <th className="px-3 py-2 text-left">Active</th>
                  <th className="px-3 py-2 text-left">Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={7} className="px-3 py-4">Cargando...</td></tr>
                ) : rows.length === 0 ? (
                  <tr><td colSpan={7} className="px-3 py-4">Sin profiles todavía.</td></tr>
                ) : rows.map((r) => (
                  <tr key={r.id} className="border-t border-white/10">
                    <td className="px-3 py-2">{r.season}</td>
                    <td className="px-3 py-2">{r.source}</td>
                    <td className="px-3 py-2">{r.source_handle}</td>
                    <td className="px-3 py-2">{r.display_name || "—"}</td>
                    <td className="px-3 py-2">{r.country_code || "—"}</td>
                    <td className="px-3 py-2">{r.active ? "Yes" : "No"}</td>
                    <td className="px-3 py-2">
                      <button onClick={() => toggleActive(r)} className="px-2 py-1 rounded border border-white/20">
                        {r.active ? "Disable" : "Enable"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
